// extracted by mini-css-extract-plugin
module.exports = {"root":"user-image_root___8qq9","value":"user-image_value__kZbsF","medium":"user-image_medium__syg3U","small":"user-image_small__vdXod","has_story":"user-image_has_story__wjSdY"};